import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import { createActivationApi } from "app/pages/activation/services/api";
import type { TrafficWidgetResponse } from "app/pages/activation/types/api";

type TrafficQueryOptions = Omit<UseQueryOptions<TrafficWidgetResponse | null>, "queryKey" | "queryFn">;

export const TRAFFIC_QUERY_KEY = "homepage-traffic";

export const useTrafficWidgetQuery = (activationId: string, options?: TrafficQueryOptions) => {
    const query = useQuery<TrafficWidgetResponse | null>({
        queryKey: [TRAFFIC_QUERY_KEY, activationId],
        enabled: !!activationId,
        queryFn: async () => {
            const api = createActivationApi();

            const result = await api.homeWithData.getTraffic(activationId);

            return result;
        },
        ...options,
        initialData: undefined,
        refetchOnMount: true,
    });

    const isEmpty = !query.isFetching && !query.isLoading && !query.data?.id;

    return { ...query, isEmpty };
};
